import React from "react";
import { MdClose } from "react-icons/md"; // Close icon
import styles from "./css/Info.module.css";

const LiquidityZoneInfo = ({ isOpen, toggleDrawer }) => {
  return (
    <div>
      {/* Collapsible Side Drawer */}
      <div className={`${styles.drawer} ${isOpen ? styles.open : ""}`}>
        <div className={styles.drawerHeader}>
          <MdClose className={styles.closeIcon} onClick={toggleDrawer} />
        </div>

        <div className={styles.infoItem}>
          <h4>What is a Liquidity Zone?</h4>
          <p>
            A Liquidity Zone is a region on a price chart where a significant concentration of buy or sell orders is
            present. These zones often appear around key levels such as support, resistance, or consolidation areas.
            They represent areas where institutional traders or market makers accumulate or distribute positions.
          </p>
          <p>
            <b>Why is it important to traders?</b> Liquidity Zones are critical for understanding market behavior. They
            help traders:
          </p>
          <ul>
            <li>Identify potential areas of price reversals or continuations.</li>
            <li>Spot regions of institutional activity.</li>
            <li>Plan strategic entry and exit points.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>1. Types of Liquidity Zones</h4>
          <p>
            <b>Buy Liquidity Zones:</b> Areas where buy orders are concentrated, often below support levels.<br />
            <b>Sell Liquidity Zones:</b> Areas where sell orders are concentrated, often above resistance levels.
          </p>
          <p>
            These zones act as magnets for price movement, as market participants seek to fill large orders in these
            regions.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>2. How to Identify Liquidity Zones</h4>
          <p>
            <b>Clustering:</b> Look for areas where price consolidates over time, forming tight ranges.<br />
            <b>Volume Spikes:</b> Use volume indicators to find areas of unusually high trading activity.<br />
            <b>Previous Highs and Lows:</b> Monitor significant highs and lows on the chart, as these are common
            liquidity zones.
          </p>
        </div>

        <div className={styles.infoItem}>
          <h4>3. Trading Around Liquidity Zones</h4>
          <p>
            Traders often use liquidity zones to anticipate where price will react. Strategies include:
          </p>
          <ul>
            <li>Placing stop-loss orders just outside liquidity zones to avoid false breakouts.</li>
            <li>Entering trades after price confirms a reaction within the zone (e.g., reversal patterns).</li>
            <li>Using liquidity zones as targets for profit-taking.</li>
          </ul>
        </div>

        <div className={styles.infoItem}>
          <h4>4. Liquidity Zone Breakouts</h4>
          <p>
            Breakouts occur when price moves forcefully through a liquidity zone, often accompanied by high volume.
            These breakouts signal a strong shift in market sentiment and are followed by continuation trends.
          </p>
          <p>
            <b>Usage:</b> Traders can use breakout strategies or wait for price to retest the zone before entering.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LiquidityZoneInfo;
